let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b1YeA")).then(() => parcelRequire('2D4CV'));